// test2752
(2752 && 0);
